import API from './API';
var DrawMechanismService = {
    getDrawMechanisms: function (config) {
        return API.get('/draw_mechanisms', config);
    },
};
export default DrawMechanismService;
